"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasBeenUpdated = exports.resetReviews = exports.deleteReply = exports.deleteReview = exports.updateReply = exports.addReply = exports.updateReview = exports.addReview = exports.storeReviews = exports.fetchReviews = void 0;

var _types = require("./types");

var fetchReviews = function fetchReviews(origin) {
  return {
    type: _types.FETCH_REVIEWS,
    origin: origin
  };
};

exports.fetchReviews = fetchReviews;

var storeReviews = function storeReviews(reviews, origin) {
  return {
    type: _types.STORE_REVIEWS,
    reviews: reviews,
    origin: origin
  };
};

exports.storeReviews = storeReviews;

var addReview = function addReview(review, origin, userInfo) {
  return {
    type: _types.ADD_REVIEW,
    review: review,
    origin: origin,
    userInfo: userInfo
  };
};

exports.addReview = addReview;

var updateReview = function updateReview(review, origin) {
  return {
    type: _types.UPDATE_REVIEW,
    review: review,
    origin: origin
  };
};

exports.updateReview = updateReview;

var addReply = function addReply(review, reviewId, origin) {
  return {
    type: _types.ADD_REPLY,
    review: review,
    reviewId: reviewId,
    origin: origin
  };
};

exports.addReply = addReply;

var updateReply = function updateReply(review, origin) {
  return {
    type: _types.UPDATE_REPLY,
    review: review,
    origin: origin
  };
};

exports.updateReply = updateReply;

var deleteReview = function deleteReview(reviewId, origin) {
  return {
    type: _types.DELETE_REVIEW,
    reviewId: reviewId,
    origin: origin
  };
};

exports.deleteReview = deleteReview;

var deleteReply = function deleteReply(replyId, origin) {
  return {
    type: _types.DELETE_REPLY,
    replyId: replyId,
    origin: origin
  };
};

exports.deleteReply = deleteReply;

var resetReviews = function resetReviews() {
  return {
    type: _types.RESET_REVIEWS
  };
};

exports.resetReviews = resetReviews;

var hasBeenUpdated = function hasBeenUpdated() {
  return {
    type: _types.UPDATED
  };
};

exports.hasBeenUpdated = hasBeenUpdated;